<!-- Title -->
<div class="text-center" *ngIf="page < 17">
    <h1>Module 5 - Taking Care of a Home</h1>
</div>

<!-- Module Content -->
<div id="module5">

    <section>
        <div *ngIf="page === 1">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video1 src="https://www.youtube.com/embed/r1dAJpV93rk" width="560" height="315" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" [routerLink]="'/RentWise'"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video1.duration / video1.speed" [delay-until]="video1.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 2">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Taking Care of a Home</h2>
                <i>Keeping your unit clean is part of your lease agreement. If you don’t keep your home clean, the landlord may deduct money from your security deposit when you move out. If the unit is excessively dirty, you can be evicted. Eviction results in a poor rental history which makes it more difficult for you to find another unit.</i>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 3">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Keeping It Clean</h2>
                <li class="bullet-point">Less chance of illness and injuries</li>
                <li class="bullet-point">May reduce some environmental asthma triggers</li>
                <li class="bullet-point">Less wear and tear to the home and possessions</li>
                <li class="bullet-point">Fewer deductions from security deposits</li>
                <li class="bullet-point">Move-out cleaning will be much easier</li>
                <li class="bullet-point">Fewer problems with roaches and other insects or rodents</li>
                <li class="bullet-point">Less fire hazard</li>
                <li class="bullet-point">Less time spent looking for things</li>
                <li class="bullet-point">Less chance of involvement of child protection service because unit is not clean</li>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 4">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video2 src="https://www.youtube.com/embed/U-U8SSiU06I" width="560" height="315" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video2.duration / video2.speed" [delay-until]="video2.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 5">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video3 src="https://www.youtube.com/embed/UHmIsCEh5Jc" width="560" height="315" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video3.duration / video3.speed" [delay-until]="video3.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 6">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Basic Cleaning Supplies and How to Use Them</h2>
                <p>Keeping your home clean requires a few supplies. </p>
                <i>Cleaners (always follow label directions): </i>
                <li class="bullet-point">Liquid detergent for washing dishes by hand (useful for many cleaning tasks; needs rinsing)</li>
                <br>
                <li class="bullet-point">Chlorine bleach (useful for disinfecting surfaces)</li>
                <li class="bullet-point">Be careful when using chlorine bleach. Do not use or spill on soft, colored surfaces and carpets because it will remove dye. Wear protective eyewear and gloves when working with chlorine bleach, and bring in fresh air or use an exhaust
                    fan or other fan. Do NOT mix chlorine bleach with ammonia cleaners. <span class="CharOverride-15">Follow label directions.</span></li>
                <li class="bullet-point">Baking soda (mild abrasive useful for cleaning counter tops and sinks)</li>
                <li class="bullet-point">Sudsing ammonia (grease cutter and oven cleaner). Do NOT mix with Chlorine bleach.</li>
                <li class="bullet-point">All-purpose, multi-surface cleaner such as Borax (dilute with water and use for most surfaces)</li>
                <br>
                <i>Other Supplies: </i>
                <br>
                <li class="bullet-point">Broom and dustpan</li>
                <li class="bullet-point">Rags (pieces of old cotton towels are great), scrub brush, or nylon scrubbing pad</li>
                <li class="bullet-point">Bucket and mop</li>
                <li class="bullet-point">Vacuum (with beater bar if you have carpeting)</li>
                <li class="bullet-point">Toilet bowl brush and plunger</li>
                <br>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="15" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 7">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video4 src="https://www.youtube.com/embed/bSTHIZmY3DE" width="560" height="315" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video4.duration / video4.speed" [delay-until]="video4.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 8">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Kitchen Cleaning Tasks</h2>
                <i>Immediately</i>
                <p>Scrape dishes after use and stack in dishpan or dishwasher. Wash or soak utensils used for cooking. Wipe up spills on floor. Wipe the table clean after every meal.</p>
                <i>Daily</i>
                <p>Wash dishes, sink, and counters. Disinfect counters and cutting boards using bleach water (1 tsp. Chlorine bleach to 1 quart water) or disinfectant like PinesolJ or LysolJ. Sweep floor. Clean stove top after every use to prevent baking-on
                    dirt. Pick up trash and empty trash can. Place unused food in airtight containers or refrigerate.</p>
                <i>Weekly</i>
                <p>Mop floors. Wash other surfaces. Vacuum and dust or damp wipe floors and other surfaces.</p>
                <i>Monthly</i>
                <p>Clean filters from range hood. Clean oven. Clean refrigerator and defrost if needed.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 9">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video5 src="https://www.youtube.com/embed/ww0EXksrx28" width="560" height="315" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video5.duration / video5.speed" [delay-until]="video5.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 10">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Bathroom Cleaning Tasks</h2>
                <i>Immediately</i>
                <p>Run exhaust fans after showers or baths — 20 minutes minimum. Rinse out sink and tub after use. Wipe up spills on floors.</p>
                <i>Weekly</i>
                <p>Wipe down sink and tub surroundings with all-purpose cleaner. Clean toilet bowl. Wipe toilet seat and outside of toilet bowl with all purpose cleaner. Wash floor with all-purpose cleaner. Clean tub with all-purpose cleaner or low abrasion
                    cleaner if needed once a week. (Abrasive cleaners can scratch surfaces making them harder to clean in the future.)</p>
                <i>As needed</i>
                <p>When small amounts of mold appear on grout or wall surface, scrub first with solution of detergent and water to remove the mold and its food sources. If needed, use 1/4 cup of chlorine bleach and one quart of water to disinfectant or remove
                    stains. Do NOT mix bleach with ammonia cleaners. Keep surfaces dry to avoid mold. Use bathroom and kitchen vent fans. Lower humidity levels.</p>


                <!-- DON'T EDIT PAST THIS LINE -->



            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 11">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Carpet Care</h2>
                <p>Use 3 foot to 6 foot long door mats on the inside and outside of entry doors to reduce tracked in soil, pollen, and other pollutants. Vacuum often. Hose off outside or wash frequently. Make sure mats are not a tripping hazard!</p>
                <i>Immediately</i>
                <p>Pick up food and clean other spills.</p>
                <i>Weekly</i>
                <p>Vacuum carpeting, especially in high traffic areas.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 12">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video6 src="https://www.youtube.com/embed/qIeXlSdCSnk" width="560" height="315" autoplay></app-youtube-player>


                <!-- EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video6.duration / video6.speed" [delay-until]="video6.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 13">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2> Safety Instructions</h2>
                <b>It is very important to use care when you bring
                            household chemicals into your home: </b>
                <li class="bullet-point">Never mix cleaning products, especially bleach and ammonia.</li>
                <li class="bullet-point">Always read instructions on the cleaning supplies before you use them.</li>
                <li class="bullet-point">Keep the room open or open a window when cleaning with household chemicals. </li>
                <li class="bullet-point">Use extra precautions when using chlorine bleach as noted above.</li>
                <li class="bullet-point">Keep cleaning products in their original containers.
                </li>
                <li class="bullet-point">Do not eat or drink while using cleaning products.
                </li>
                <li class="bullet-point">Always keep all cleaning supplies out of the reach of children and pets.</li>
                <li class="bullet-point">Keep this number by the phone in case a child gets into the cleaning products.</li>
                <h3>Poison Center (800) 222‑1222 or in the Omaha area, (402) 955‑5555</h3>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 14">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video7 src="https://www.youtube.com/embed/W_Gn90yyosY" width="560" height="315" autoplay></app-youtube-player>


                <!-- EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video7.duration / video7.speed" [delay-until]="video7.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 15">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Pests</h2>
                <p>Landlords are generally responsible for pest-free rentals, but incoming tenants should always inspect the rental before they sign a lease. Unfortunately, tenants may not have the expertise in knowing signs of cockroaches, bed bugs and
                    rodents. It would be a good idea to ask other tenants in an apartment building — especially neighboring units — about any pest problems they might know about. Do this before you sign the lease.</p>
                <h3>Cockroach Control</h3>
                <p>Why worry about roaches? Roaches contaminate food, contribute to allergies and can trigger asthma in persons who are sensitive to the cockroach allergens. It is easier to keep them out than to get rid of them once they are part of your
                    home.
                </p>
                <i>How to prevent having roaches</i>
                <li class="bullet-point">Don’t bring cockroaches with you. Inspect items when you pack. Try to use new boxes or clean plastic totes when moving.</li>
                <i>Don’t feed or water cockroaches</i>
                <li class="bullet-point">Keep all food in tightly covered containers. This includes pet food which feeds cockroaches if left out overnight. Wash dirty dishes before bedtime. Clean up grease splatters and grease in and on the stove. Clean cabinets especially under
                    sink areas. As much as possible, eliminate easy sources of water. Take garbage outside or to the control area daily. Fix leaky faucets and pipes, caulk or plug holes around pipes. Plug holes in walls, windows, and doors.</li>
                <i>Getting rid of roaches</i>
                <p>Call the local University of Nebraska–Lincoln Extension office for publications on controlling cockroaches and other insects and rodents. Cockroach control tactics include eliminating clutter, which can provide hiding places; vacuuming;
                    using baits and insect growth regulators; and crack and crevice treatments targeting cockroach hiding places. Baits and insect growth regulators are effective long-term controls; baseboard treatments are NOT effective long-term controls
                    because cockroach populations rebound.</p>
                <h3>Bed Bugs</h3>
                <p>Disputes between landlords and tenants over who is to blame for a bed bug infestation are increasingly common. A landlord/property manager should not be renting units that are infested, but sometimes previous tenants leave without informing
                    management about the problem and the management company really doesn’t know. If bed bugs are found within a few weeks of moving into an apartment or home, first contact the landlord or property manager. If management seems unresponsive,
                    contact your local health department for assistance.</p>
                <p>It is good to remember that human activity moves bed bugs from place to place. The most likely ways people get bed bugs are:</p>
                <li class="bullet-point">Traveling and staying in infested hotels/motels. Some occupations are more at risk. For example, if you are a truck driver or frequent business traveler, you will have a greater chance of encountering bed bugs when you travel. Homeless
                    shelters and emergency shelters are also locations where bed bugs can be a problem.</li>
                <li class="bullet-point">Having someone who has bed bugs at home stay overnight in your place, or even visit your home. Don’t store boxes of household goods that belong to other people, even if they are friends.</li>
                <li class="bullet-point">Visiting or spending time at someone’s home who has bed bugs.</li>
                <li class="bullet-point">Bringing used, infested furniture into your home will cause an instant bed bug infestation. You should never bring furniture home you find on the curb or next to a dumpster.</li>
                <li class="bullet-point">Be very careful buying used furniture. There have been examples of unethical people selling bed bug-infested furniture to unsuspecting people.</li>
                <p>The University of Nebraska has resources to help people prevent bed bugs from getting in their home. Check out: <a href="http://lancaster.unl.edu/pest/resources/343BBPrevention.pdf"><span class="Hyperlink CharOverride-23">http://lancaster.unl.edu/pest/resources/343BBPrevention.pdf</span></a>
                </p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="60" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 16">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Lead Paint Hazards</h2>
                <i>How do you know if there is a lead paint hazard?</i>
                <li class="bullet-point">Landlords must tell you if they know of any lead hazard in the home before they rent to you.</li>
                <li class="bullet-point">Landlords must tell you about lead paint hazards and what to do about them before you rent.</li>
                <li class="bullet-point">A blood test tells whether your child has lead poisoning.</li>
                <li class="bullet-point">Note: Dust wipe tests can be sent to labs that test for lead. Consult yellow pages or local or area health department or extension offices.</li>
                <i>Lead paint:</i>
                <li class="bullet-point">can be found in homes built before 1978.</li>
                <li class="bullet-point">is considered a hazard when paint is peeling, chipping, chalking, cracking or resulting in dust.</li>
                <li class="bullet-point">is often on surfaces where children can chew or that have a lot of wear or friction like windows and doors.</li>
                <li class="bullet-point">can be found in soil near the outside of older homes.</li>
                <i>Prevention:</i>
                <li class="bullet-point">Test children, especially children under the age of six for blood lead levels.</li>
                <li class="bullet-point">Wet wipe or wet mop hard surfaces and floors regularly.</li>
                <li class="bullet-point">Remove old carpet by first spraying carpet with water, cut into strips and roll inward while spraying the back side. Cover and wrap in plastic and dispose in trash. Thoroughly vacuum the floor underneath with a vacuum that has a HEPA filter,
                    and wet clean the floor underneath after the vacuuming dust settles. Wet clean a second time.</li>
                <li class="bullet-point">Keep children’s hands and toys clean.</li>
                <p>For additional information, see the <i>Help Yourself to a Healthy Home: Protect Your Children’s Health, online at <a href="https://www.hud.gov/sites/documents/DOC_11880.PDF"><span class="Hyperlink CharOverride-23">https://www.hud.gov/sites/documents/DOC_11880.PDF</span></a></i>.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next()">Quiz<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>
</div>

<!-- Quiz Mode -->
<section *ngIf="page === 17">
    <app-quiz-questions [questions]="questions" [moduleNumber]="5" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>
